import {
  requiredString,
  optionalString,
  optionalBoolean,
  optionalFile,
  optionalCurrencyPence,
  optionalIntegerMin,
  optionalNonNegativeNumber,
  createResourceSchema
} from './common'

export const venueSchema = createResourceSchema({
  name: requiredString('Name'),
  description: optionalString,
  capacity: optionalIntegerMin(1, 'Capacity'),
  min_booking_notice_hours: optionalNonNegativeNumber('Minimum booking notice'),
  setup_time_minutes: optionalNonNegativeNumber('Setup time'),
  base_hire_fee_pence: optionalCurrencyPence('Base hire fee'),
  active: optionalBoolean,
  image: optionalFile
})
